export const SET_RADAR_WIDGET = 'SET_RADAR_WIDGET'
export const REMOVE_RADAR_WIDGET = 'REMOVE_RADAR_WIDGET'

export function setRadarWidget(data) {
  return dispatch => dispatch({type: SET_RADAR_WIDGET, data});
}

export function removeRadarWidget() {
  return dispatch => dispatch({type: REMOVE_RADAR_WIDGET});
}


// WEBPACK FOOTER //
// ./js/actions/widget/index.js